import tw, { styled } from 'twin.macro'

export const Screen = styled.div`
  ${tw`flex flex-col dark:text-white h-full`}
`

export const ContentWrapper = styled.div`
  ${tw`max-w-4xl mx-auto py-12 lg:py-24`}
`

export const PressReleaseTitle = styled.h1`
  ${tw`px-6 lg:px-10 text-5xl pb-12 leading-tight`}
`

export const PressReleaseContent = styled.div`
  ${tw`px-6 lg:px-10`}
`

export const PressReleaseFooter = styled.div`
  ${tw`px-6 lg:px-10 pt-6`}
`

export const PressReleaseFooterCopyright = styled.p`
  ${tw`pt-5`}
`

export const PressReleaseDate = styled.time`
  ${tw`pl-6 lg:pl-10 text-base text-gray-300 tracking-widest`}
`
